import { beginTask, endTask } from 'redux-nprogress';
import { redirect } from 'redux-first-router';
// import { selectQuery } from '../../../../store/reducers/location.selectors';
import { ACCOUNT_INFORMATION_VIEW } from '../../AccountInfo/module/accountInfo';
import viewNames from '../../../../store/actions/view.types';
import routes from '../../../routes.global';

export const STORE_KEY = 'RequestUsername';
export const selectRequestUsernameState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  error: null,
  email: null,
  submissionSuccess: null,
};

const requestUsernameReducer = (state = initialState, action) => {
  const handler = actions[action.type];
  return handler ? handler(state, action) : state;
};

export default requestUsernameReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const SUBMIT_USERNAME_REQUEST = `${STORE_KEY}/SUBMIT_USERNAME_REQUEST`;
export const SUBMIT_USERNAME_SUCCESS = `${STORE_KEY}/SUBMIT_USERNAME_SUCCESS`;
export const SUBMIT_USERNAME_ERROR = `${STORE_KEY}/SUBMIT_USERNAME_ERROR`;
export const RESET_VIEW = `${STORE_KEY}/RESET_VIEW`;

export const resetView = () => ({
  type: RESET_VIEW,
});

export const submitUsernameError = error => ({
  type: SUBMIT_USERNAME_ERROR,
  payload: { error },
});

export const submitUsernameSuccess = () => ({
  type: SUBMIT_USERNAME_SUCCESS,
});

export const submitUsernameRequest = email => ({
  type: SUBMIT_USERNAME_REQUEST,
  payload: { email },
});

actions[RESET_VIEW] = state => ({ ...state,
  ...initialState,
});

actions[SUBMIT_USERNAME_REQUEST] = (state, { payload }) => ({ ...state,
  email: payload.email,
  error: null,
  submissionSuccess: null,
});

actions[SUBMIT_USERNAME_ERROR] = (state, { payload }) => ({ ...state,
  error: payload.error,
  submissionSuccess: false,
});

actions[SUBMIT_USERNAME_SUCCESS] = state => ({ ...state,
  error: null,
  submissionSuccess: true,
});


// ------------------------------------
// Submit email for Username reminder
// ------------------------------------
export const handleSubmitUsernameRequest = email => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(submitUsernameRequest(email));
    await api.user.submitUsernameRequest({ email });
    dispatch(submitUsernameSuccess());
  } catch (error) {
    console.log('Error from call to api.user.getUserInfo:\n %O', error);
    dispatch(submitUsernameError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const REQUEST_USERNAME_VIEW = `${STORE_KEY}/REQUEST_USERNAME_VIEW`;
viewNames[REQUEST_USERNAME_VIEW] = 'RequestUsername';
routes[REQUEST_USERNAME_VIEW] = {
  path: '/request-username',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    if (loggedIn) {
      await dispatch(redirect({ type: ACCOUNT_INFORMATION_VIEW }));
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/views/UsernameRequest/module/requestUsername.js